import React, { ReactNode } from 'react'
import { Button } from 'primereact/button'

import useText from '../../hooks/useText'
import { Dialog } from '../../uikit/Dialog'

export type InformationDialogProps = {
    visible: boolean
    title: string
    message: ReactNode
    onHide: () => void
}

export function InformationDialog({ visible, title, message, onHide }: InformationDialogProps): React.ReactElement {
    const text = useText()

    const footer = (
        <div className="flex justify-content-end">
            <Button type="button" label={text('btnOkay')} icon="pi pi-check" onClick={onHide} />
        </div>
    )

    return (
        <Dialog
            visible={visible}
            header={title}
            onHide={onHide}
            footer={footer}
            style={{ width: '30rem' }}
            data-testid="information-dialog"
        >
            <div className="text-sm line-height-3" data-testid="information-dialog-message">
                {message}
            </div>
        </Dialog>
    )
}
